<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/07/img1.png")
    .content
      .case-num Vol.07
      .case-title 65㎡精致小户型，处女座男生的神仙日子
      .line1 每个细节精心设计、专门的娱乐室、融入潮流元素，这简直是年轻人的梦想屋啊
      .line1 窝仔今天拜访的客户，是一名处女座男生。一起看看他精心打造的65㎡精致小屋吧。
      .cont-title 关于屋主
      .line1 屋主华先生追求精致生活，在房子的装修中，融入了很多自己的心思。
      .line1 华先生与心爱的人相识3年，两人有很多共同爱好，也很有默契。
      .line1 虽然现在是独自居住，但他计划这套房子以后用作婚房，所以在装修中也加入很多对未来生活的期待。
      img.cont-img(src="~assets/case/07/img2.jpg")
      .cont-title 「房子的基本信息」
      .line1
        <span>坐标：上海静安</span>
        <span>面积：65㎡</span>
        <span>户型：两室一厅</span>
      img.cont-img(src="~assets/case/07/img3.jpg")
      .line1 虽然屋主年初时才搬进来，但整洁程度还是超出了我们的预计。处女座的“天生优势”被发挥得淋漓尽致。
      .line1 不仅如此，精心搭配的装饰花卉，加之屋主心爱的玄凤鹦鹉，给我们呈上了一场“鸟语花香”的视听享受。
      .cont-title 玄关&客厅<br/>三大巧思，给小户型加分
      .line1 还没进屋，就发现了主人的小心思。
      .line1 大门上，主人亲手粘贴了毛毡。“Home is where we are”，给人回到家的温馨感。
      img.cont-img(src="~assets/case/07/img4.png")
      .line1 进入大门，第一个空间是客餐厅。
      .line2 巧思1：精心搭配，展示精致生活
      .line1 客厅面积不大，家具摆放比较紧凑，没有多余的物件。给人的整体感觉，是精致、轻奢。
      img.cont-img(src="~assets/case/07/img5.jpg")
      .line1 硬装色调定调之后，软装其实无需过分复杂，只要家具挑选得当，就轻松搭配出了精致轻奢风。
      img.cont-img(src="~assets/case/07/img6.jpg")
      .line1 深蓝色的伊丽莎白沙发，颜色沉静，坐感柔软，一进屋就可以立刻坐下放松。
      img.cont-img(src="~assets/case/07/img7.jpg")
      .line1 粉色、灰色的安普天鹅绒抱枕，跟深蓝形成对比，把优雅气质提到最佳。
      img.cont-img(src="~assets/case/07/img8.jpg")
      .line1 沙发的丝绒材质，配上手感顺滑的桑德罗羊皮毯，让原本简洁的客厅，更有了一丝低调的奢华质感。
      img.cont-img(src="~assets/case/07/img9.jpg")
      .line1 在木地板上铺一张圆形的莫西兔毛地毯，中和了木地板的硬朗，把温馨感衬托到极致。
      img.cont-img(src="~assets/case/07/img10.jpg")
      .line2 巧思2：墙面做柜体，增加收纳空间
      .line1 很多人会担心，小户型没有足够的收纳空间，设计师给了很好的解决方案。<br/> 把客厅墙面打造成柜体，增加了不少的收纳空间。
      img.cont-img(src="~assets/case/07/img11.jpg")
      .line1 白色柜门与白色墙面融为一体。厨房的门，也在其中。<br/> 把凌乱和油烟，都藏了起来。做饭的油烟和吵闹，也不会打扰到公共区域。
      img.cont-img(src="~assets/case/07/img12.jpg")
      .line2 巧思3：餐桌靠窗设计，不占地又实用
      .line1 紧邻主沙发的，是一张嵌入式餐桌，与墙面收纳柜连成一体。
      img.cont-img(src="~assets/case/07/img13.jpg")
      .line1 挨着窗户，在这里吃饭、喝茶时，还可以欣赏到窗外的景色。
      img.cont-img(src="~assets/case/07/img14.jpg")
      .line1 搭配两张懂窝餐椅，绒面材质和金属椅腿，轻巧不繁杂，轻奢的质感与沙发区域相映成趣。
      img.cont-img(src="~assets/case/07/img15.jpg")
      .cont-title 娱乐室 <br/>次卧改成娱乐室，使用率翻倍
      .line1 房子的重头戏之一，就是华先生专门打造的娱乐室。<br/> 这个房间本来是次卧，改成娱乐室，使用率更高，也弥补了客餐厅有限的功能。
      img.cont-img(src="~assets/case/07/img16.jpg")
      .line1 娱乐室里，靠墙摆放了一台钢琴。因为两人都爱好钢琴，华先生为此专门购入。
      img.cont-img(src="~assets/case/07/img17.jpg")
      .line1 聊得兴起，他现场为我们弹奏了几首曲子，屋里立刻充满了艺术气息。
      img.cont-img(src="~assets/case/07/img18.jpg")
      .line1 除了钢琴，还计划在这间房配一台投影仪，在家也能随时欣赏精彩大片。<br/> 一张舒服的沙发，是看电影的必备。
      .line1 米白色的巴罗羽绒填充沙发，与深粉色墙面搭配，安静沉稳。
      img.cont-img(src="~assets/case/07/img19.jpg")
      .line1 一张小茶几，方便放零食、茶水。跟客厅一样的圆形兔毛地毯，让房间更加温暖，就算冬天光脚也不觉得冷，观影的同时更加放松。
      img.cont-img(src="~assets/case/07/img20.jpg")
      .line1 灰色系棉麻质地的冬丽抱枕，跟浅色沙发刚好搭配，也与地毯的颜色呼应。
      img.cont-img(src="~assets/case/07/img21.jpg")
      .line1 角落的欧文黄铜地灯，光线柔和温馨，把娱乐室烘托得更加惬意。
      img.cont-img(src="~assets/case/07/img22.jpg")
      .cont-title 卧室<br/> 沉静不失浪漫，还有“金屋藏娇”
      .line1 卧室的配色跟娱乐室截然不同，沉静的蓝色墙面，一走进来，人就自然放松了。<br/> 灰色的娜塔莎丝绒双人床，搭配蓝色的墙面，显得和谐优雅。
      img.cont-img(src="~assets/case/07/img23.jpg")
      .line1 床上艾塔四件套也经过了精心挑选，灰蓝双面配色，高密贡缎质地。
      img.cont-img(src="~assets/case/07/img24.jpg")
      .line1 华先生还特意在床头摆了鲜花，生活精致程度可见一斑。闻着花香，睡在这舒服的大床上，梦也更甜美了。
      img.cont-img(src="~assets/case/07/img25.jpg")
      .line1 房间一角的海尔格羽毛落地灯，光线轻柔，把卧室的氛围营造得更浪漫。
      img.cont-img(src="~assets/case/07/img26.jpg")
      img.cont-img(src="~assets/case/07/img27.jpg")
      .line1 “躲”在房间阳台的，是华先生心爱的宠物“秋秋”（音），一只漂亮的玄凤鹦鹉。
      img.cont-img(src="~assets/case/07/img28.jpg")
      .line1 它居住的鸟笼跟主人的家一样精致，娱乐、饮食设施一应俱全，堪称鸟笼“豪宅”。
      .cont-title 厨房&卫生间<br/> 简洁实用，同时紧跟潮流
      .line1 厨房和卫生间则以白色为主色调，让小空间不显拥挤。
      img.cont-img(src="~assets/case/07/img29.jpg")
      .line1 卫生间采用了时下流行的谷仓门设计，别出心裁，同时也更节省空间。
      img.cont-img(src="~assets/case/07/img30.jpg")
      .line1 镜子也紧跟科技，圆形镜面围绕触控灯带，洗漱、化妆时照得一清二楚。
      img.cont-img(src="~assets/case/07/img31.jpg")
      .cont-title 装修巧思
      .line1 •  房子的功能可以因人而异，比如把次卧改成娱乐室
      .line1 •  定好了硬装，软装无需复杂，几件家具就能搭出精致感
      .line1 •  墙面改柜体，增加收纳空间，采用白色柜门，与墙面融为一体
      .line1 •  卫生间采用谷仓门设计，既新潮又节省空间
      .cont-title1  Q&A
      .line2 <span>Q：为什么会选择懂窝的家具呢？</span>挑选家具时，设计师推荐了我另一家。但是那家的色调太深沉了。后来我发现了懂窝，设计更丰富，性价比也高，所以就在懂窝买了。
      .line2 <span>Q：在软装搭配方面有什么心得？</span>懂窝的软装搭配师有帮我推荐。然后我根据家里的装修基调，加上自己的喜好，挑选了几款家具，碰巧挑了两款懂窝的热卖沙发。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin-top: r(60)
      width: 100%
    .cont-title
      margin-top: r(64)
      font-weight: bolder
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .cont-title1
      margin-top: r(110)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .line2
      margin: r(31) auto 0
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      line-height: r(34)
      span
        display: block
        color: #000000
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case7.vue?3bd28d8a